export const Intent = {
  ChangeAudio: 'change-audio',
  ChangeQuality: 'change-quality',
  ChangeSubtitles: 'change-subtitles',
  ClosePlayer: 'close-player',
  DisableSubtitles: 'disable-subtitles',
  EnableSubtitles: 'enable-subtitles',
  GoLive: 'go-live',
  PlayNext: 'play-next',
  PlayNextEpisode: 'play-next-episode',
  PlayPrevious: 'play-previous',
  Rewind: 'rewind',
  Seek: 'seek',
  StartAd: 'start-ad',
  EndAd: 'end-ad',
  ToggleMute: 'toggle-mute',
  ToggleCast: 'toggle-cast',
  TogglePause: 'toggle-pause',
  TogglePip: 'toggle-pip',
  Unmute: 'unmute',
} as const
export type Intent = (typeof Intent)[keyof typeof Intent]
